<template>
  <div>
    <v-tabs>
      <v-tabs-slider></v-tabs-slider>

      <v-tab>All Cells</v-tab>
      <v-tab>Available Cells List</v-tab>
      <!-- <v-tab>Unbalanced Cells List</v-tab> -->
      
      <v-tab-item>
        <AllCells />
      </v-tab-item>
      <v-tab-item>
        <AvailableCells />
      </v-tab-item>
      <v-tab-item>
        <AvailableUnbalancedCells />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import AvailableCells from "./AvailableCell.vue";
import AvailableUnbalancedCells from "./AvailableUnbalancedCells.vue";
import AllCells from "./AllCells.vue";

export default {
  name: "Batteries",
  components: {
    AvailableCells,
    AvailableUnbalancedCells,
    AllCells
}
};
</script>